<script>
    import { closeModal } from 'svelte-modals';

    // provided by <Modals />
    export let isOpen;
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <div class="actions">
                <div class="delete-button" on:click={closeModal}>
                    <i class="fas fa-times" />
                </div>
            </div>
            <div>Privacy Text</div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        min-width: 240px;
        max-width: 800px;
        border-radius: 6px;
        padding: 16px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
    }

    .actions {
        margin: 10px;
        display: flex;
        justify-content: flex-end;
    }
    .actions i {
        font-size: 15px;
    }
</style>
